import axios from "axios";
import ApiEndPoint from "./ApiEndPoint";
const accessToken = localStorage.getItem("accessToken");

export const login = (params) => {
  return axios.post(
    ApiEndPoint.LOGIN_USER,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const signUp = (params) => {
  return axios.post(
    ApiEndPoint.SIGNUP_USER,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const customerList = (params) => {
  return axios.get(
    `${ApiEndPoint.ALL_LOAN_USER}?page_size=${
      params.pageSize || "ALL"
    }&sortBy=${params.sortBy || null}&sort=${params.sort || "desc"}&by_search=${
      params.search
    }&by_start_date=${params.startDate}&by_end_date=${params.endDate}`,
    {
      "Content-Type": "application/json",
    }
  );
};

//GET_CUSTOMERS
export const customersDetails = (params = {}) => {
  if(accessToken){
    return axios.get(`${ApiEndPoint.CUSTOMERS}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

export const customersReportPdf = (params = {}) => {
  if(accessToken){
    return axios.get(`${ApiEndPoint.CUSTOMERS_REPORT_PDF}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

//CREATE_CUSTOMERS
export const createCustomers = (customerData) => {
  if(accessToken){
  return axios.post(`${ApiEndPoint.CUSTOMERS}`, customerData, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`
    }
  });
  }
};
//CREATE_CUSTOMERS
export const getCustomers = (cutomerId) => {
  if(accessToken){
  return axios.get(`${ApiEndPoint.CUSTOMERS}${cutomerId}/`, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`
    }
  });
  }
};

//UPADTE_CUSTOMERS
export const updateCustomers = ({customerData,userId}) => {
  if(accessToken){
  return axios.put(`${ApiEndPoint.CUSTOMERS}${userId}/`, customerData, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`
    }
  });
  }
};

//GET_USERS
export const usersDetails = (params = {}) => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.USERS}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

// EDIT_USERS
export const editUser = (data) => {
  if (accessToken) {
    const url = `${ApiEndPoint.USERS}`;
    return axios.patch(url,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

// DELETE_USER
export const deleteUser = (data) => {
  if (accessToken) {
    const url = `${ApiEndPoint.USERS}`;
    return axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      data: data
    });
  }
};

//CREATE_USERS
export const createUsersDetails = (formData) => {
  if(accessToken){
    return axios.post(`${ApiEndPoint.USERS}`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }
};

//USERS_DETAILS
export const usersDetailsSettings = () => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.USERS_DETAILS}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }
};

// UPDATE_DETAILS
export const updateDetailsSettings = (userDetails) => {
  if (accessToken) {
    return axios.put(`${ApiEndPoint.USERS_DETAILS}`,
      userDetails, // Pass the user details data here
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

// CHANGE_PASSWORD
export const changePassword = (formData) => {
  if(accessToken){
    return axios.post(`${ApiEndPoint.CHANGE_PASSWORD}`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }
};

// CHANGE_PIN
export const changePin = (formData) => {
  if(accessToken){
    return axios.post(`${ApiEndPoint.CHANGE_PIN}`, formData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }
};

//CUSTOMERS
export const companyList = () => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.COMPANY}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }
};

// CUSTOMER_ACTIVE
export const companyListActive = (data) => {
  if (accessToken) {
    return axios.put(`${ApiEndPoint.COMPANY}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

//DASHBOARD
export const dashboardList = (params = {}) => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.DASHBOARD}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

// DASHBOARD_TRANSACTIONS
export const dashboardTransactions = (data) => {
  console.log(data, 888888888888)
  if (accessToken) {
    return axios.post(`${ApiEndPoint.DASHBOARD}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

// VERIFY_PIN
export const verifyPin = (data) => {
  if (accessToken) {
    return axios.post(`${ApiEndPoint.VERIFY_PIN}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

// UPDATE_TRANSACTIONS
export const updateTransactions = (data) => {
  if (accessToken) {
    const { customer } = data;
    const url = `${ApiEndPoint.UPDATE_TRANSACTION}${customer}/update/`;
    return axios.patch(url,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`
        }
      }
    );
  }
};

// DELETE_TRANSACTIONS
export const deleteTransactions = (data) => {
  if (accessToken) {
    const { customer } = data;
    const url = `${ApiEndPoint.UPDATE_TRANSACTION}${customer}/`;
    return axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      data: data
    });
  }
};

//USER_TRANSACTIONS
export const userTransactionList = (params = {}) => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.USER_TRANSACTIONS}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

//USER_TRANSACTIONS
export const deleteTransaction = (params = {}) => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.CLOSE}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: params
    });
  }
};

export const bookMark = (id) => {
  if (accessToken) {
    return axios.get(`${ApiEndPoint.BOOK_MARK}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      params: {"id" : id}
    });
  }
};
